import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=9c536e10&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=ts&"
export * from "./Locations.vue?vue&type=script&lang=ts&"
import style0 from "./Locations.vue?vue&type=style&index=0&id=9c536e10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c536e10",
  null
  
)

export default component.exports